import React, { FC } from "react";

import {
  FormattedPeriodicValue,
  FormattedPeriodicValueProps,
} from "@I18n/Components/FormattedPeriodicValue/FormattedPeriodicValue";
import { IAppCurrency } from "@App/types";
import { Money } from "../Money/Money";

type RateUnit = FormattedPeriodicValueProps["unit"] | "flat";

export type RateProps = {
  cents: number;
  currency: IAppCurrency;
  unit?: RateUnit;
} & Pick<FormattedPeriodicValueProps,"isShortFormat">;

export const Rate: FC<RateProps> = ({ cents, unit, currency,isShortFormat }) => {
  const rate = <Money cents={cents} currency={currency} />;

  if (unit === "flat" || !unit) return rate;

  return <FormattedPeriodicValue value={rate} unit={unit} isShortFormat={isShortFormat} />;
};
